import type { Currency } from "@/models/types";

export const CURRENCIES: Currency[] = [
  { code: "MXN", symbol: "$", name: "Peso mexicano", locale: "es-MX" },
  { code: "USD", symbol: "$", name: "Dólar estadounidense", locale: "en-US" },
  { code: "EUR", symbol: "€", name: "Euro", locale: "es-ES" },
  { code: "COP", symbol: "$", name: "Peso colombiano", locale: "es-CO" },
  { code: "ARS", symbol: "$", name: "Peso argentino", locale: "es-AR" },
  { code: "CLP", symbol: "$", name: "Peso chileno", locale: "es-CL" },
];

export function getCurrency(code: string): Currency {
  return CURRENCIES.find((c) => c.code === code) ?? CURRENCIES[0];
}

export function formatCurrency(
  amount: number,
  currencyCode: string = "MXN",
): string {
  const currency = getCurrency(currencyCode);
  const hasDecimals = currency.code !== "CLP";
  const value = new Intl.NumberFormat(currency.locale, {
    style: "currency",
    currency: currency.code,
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(amount);

  // Añadir código de moneda al final para claridad visual
  return `${value} ${currency.code}`;
}

export function formatAmount(
  amount: number,
  currencyCode: string = "MXN",
): string {
  const currency = getCurrency(currencyCode);
  const hasDecimals = currency.code !== "CLP";
  return new Intl.NumberFormat(currency.locale, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(amount);
}